import { use } from 'react'

import { BidMemberListModalStoreContext } from '../contexts/StoreContext'

export const useBidMemberListModalStore = () => {
  const context = use(BidMemberListModalStoreContext)

  if (!context) {
    throw new Error(
      'The component must be used within a BidMemberListModalContext'
    )
  }

  return context
}
